import { createFileRoute, notFound } from "@tanstack/react-router";
import EsInsurancePage, {
  buildEsInsuranceSchema,
} from "@/pages/es/EsInsurancePage";
import { findEsInsuranceBySlug } from "@/pages/es/esInsuranceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

export const Route = createFileRoute("/es/insurance/$slug")({
  head({ params }) {
    const config = findEsInsuranceBySlug(params.slug);
    if (!config) {
      return {
        meta: [
          { title: "No encontrado" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const url = `${SITE_URL}/es/insurance/${config.slug}`;
    const title = `${config.seoTitle} | Neuro Wellness`;
    return {
      meta: [
        { title },
        { name: "description", content: config.seoDescription },
        { property: "og:title", content: title },
        { property: "og:description", content: config.seoDescription },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "es_ES" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflang(`/${config.slug}`),
      ],
      scripts: buildEsInsuranceSchema(config).map((s) => ({
        type: "application/ld+json",
        children: JSON.stringify(s),
      })),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  const config = findEsInsuranceBySlug(slug);
  if (!config) throw notFound();
  return <EsInsurancePage config={config} />;
}
